import { render, staticRenderFns } from "./AssignmentDiscussion.vue?vue&type=template&id=4474b782&scoped=true&"
import script from "./AssignmentDiscussion.vue?vue&type=script&lang=js&"
export * from "./AssignmentDiscussion.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentDiscussion.vue?vue&type=style&index=0&id=4474b782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4474b782",
  null
  
)

export default component.exports